export const TABLE_SETTINGS_BUTTON_LABEL = 'Column settings';
export const MIN_COLUMNS_NUMBER_FOR_SCROLL = 12;
